<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue';

const props = defineProps({
  label: { type: String, default: 'Select Date Range' },
  modelValue: Object, // Expected format: { from: '', to: '' }
});

const emit = defineEmits(['update:modelValue']);

const fromDate = ref(props.modelValue?.from || '');
const toDate = ref(props.modelValue?.to || '');
const fromMenu = ref(false);
const toMenu = ref(false);

const formattedFromDate = computed(() => fromDate.value ? formatDate(fromDate.value) : '');
const formattedToDate = computed(() => toDate.value ? formatDate(toDate.value) : '');

const formatDate = (date) => {
  if (!date) return '';
  if (typeof date === 'object') {
    date = date.toLocaleDateString('en-CA'); // Convert Date object to YYYY-MM-DD
  }
  if (typeof date === 'string' && date.includes('-')) {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`; // Convert to DD-MM-YYYY
  }
  return date;
};

const updateDate = () => {
  emit('update:modelValue', { from: fromDate.value, to: toDate.value });
};

const clearFromDate = () => {
  fromDate.value = '';
  updateDate();
};

const clearToDate = () => {
  toDate.value = '';
  updateDate();
};

watch(() => props.modelValue, (newVal) => {
  fromDate.value = newVal?.from || '';
  toDate.value = newVal?.to || '';
});
</script>

<template>
  <v-sheet class="filter-card">
    <span class="filter-card-label">{{ label }}</span>
    <v-row dense>
      <!-- From Date Picker -->
      <v-col cols="6">
        <v-menu v-model="fromMenu" :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ props }">
            <v-text-field v-bind="props" :model-value="formattedFromDate" label="From Date" readonly clearable variant="outlined" @click:clear="clearFromDate" density="compact" />
          </template>
          <v-date-picker v-model="fromDate" @update:modelValue="updateDate" density="compact" />
        </v-menu>
      </v-col>

      <!-- To Date Picker -->
      <v-col cols="6">
        <v-menu v-model="toMenu" :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ props }">
            <v-text-field v-bind="props" :model-value="formattedToDate" label="To Date" readonly clearable variant="outlined" @click:clear="clearToDate" density="compact" />
          </template>
          <v-date-picker v-model="toDate" :min="fromDate" @update:modelValue="updateDate" density="compact" />
        </v-menu>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style scoped>
.full-width {
  width: 100%;
}
</style>